import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';

const ViewDormantPracticesToggle = ({ styles = {} }) => {
    // bool tied to the view dormant practices toggle
    const includeDormantPractices = useSelector(state => state.practice.includeDormantPractices);
    const dispatch = useDispatch();
    const onChange = useCallback(() => {
        dispatch(
            actions.practice.setIncludeDormantPractices(
                !includeDormantPractices
            )
        )
    }, [includeDormantPractices, dispatch]);

    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={includeDormantPractices}
            label='View Dormant Practices'
        />
    );
};

export default ViewDormantPracticesToggle;
